import {connect} from 'react-redux';
import Toolbar, {ToolbarProps} from './Toolbar';
import ReduxState from '../../types/ReduxState';
import ReviewModel from '../../types/ReviewModel';
import UserModel from '../../types/UserModel';

const mapStateToProps = (state: ReduxState): ToolbarProps => {
   return {
      review: state.currentReview || {} as ReviewModel,
      currentUser: state.currentUser || {} as UserModel
   };
};

export default connect(mapStateToProps, null)(Toolbar);
